import { render, staticRenderFns } from "./pixDetails.vue?vue&type=template&id=68baa762&scoped=true"
import script from "./pixDetails.vue?vue&type=script&lang=js"
export * from "./pixDetails.vue?vue&type=script&lang=js"
import style0 from "./pixDetails.vue?vue&type=style&index=0&id=68baa762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68baa762",
  null
  
)

export default component.exports